/**
 * Runtime-конфигурация (AIT-392).
 *
 * Значения берутся в таком порядке:
 *  1. `window.__ENV__` — файл `/env.js`, который контейнер генерирует при старте из
 *     переменных окружения (docker/entrypoint.sh). Один образ для dev/qa/prod.
 *  2. `process.env.REACT_APP_*` — значения, вшитые CRA на сборке (локальный запуск,
 *     e2e, и запасной вариант, пока деплой не передаёт переменные в контейнер).
 *
 * CRA подставляет только литеральные обращения `process.env.REACT_APP_X`, поэтому
 * ключи перечислены явно, а не читаются динамически.
 */
export type EnvKey =
  | 'REACT_APP_API_BASE_URL'
  | 'REACT_APP_CONNECTOR_BASE_URL'
  | 'REACT_APP_VUSER_BASE_URL'
  | 'REACT_APP_WS_URL'
  | 'REACT_APP_WORKFLOW_TEST_CHAT'
  | 'REACT_APP_CONNECTOR_SERVICE_TOKEN'
  | 'REACT_APP_RECAPTCHA_SITE_KEY'
  | 'REACT_APP_POSTHOG_KEY'
  | 'REACT_APP_POSTHOG_HOST';

declare global {
  interface Window {
    __ENV__?: Partial<Record<EnvKey, string>>;
  }
}

const buildTime: Record<EnvKey, string | undefined> = {
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_CONNECTOR_BASE_URL: process.env.REACT_APP_CONNECTOR_BASE_URL,
  REACT_APP_VUSER_BASE_URL: process.env.REACT_APP_VUSER_BASE_URL,
  REACT_APP_WS_URL: process.env.REACT_APP_WS_URL,
  REACT_APP_WORKFLOW_TEST_CHAT: process.env.REACT_APP_WORKFLOW_TEST_CHAT,
  REACT_APP_CONNECTOR_SERVICE_TOKEN: process.env.REACT_APP_CONNECTOR_SERVICE_TOKEN,
  REACT_APP_RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  REACT_APP_POSTHOG_KEY: process.env.REACT_APP_POSTHOG_KEY,
  REACT_APP_POSTHOG_HOST: process.env.REACT_APP_POSTHOG_HOST,
};

/** Значение переменной или пустая строка; runtime-значение имеет приоритет над сборочным. */
export function readEnv(key: EnvKey): string {
  const runtime = typeof window !== 'undefined' ? window.__ENV__?.[key] : undefined;
  const value = runtime !== undefined && runtime !== '' ? runtime : buildTime[key];
  return value === undefined || value === null ? '' : String(value).trim();
}
